import React, {useEffect, useState} from "react";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import sixteenth from "./sixteenth.png"
import triplet from "./triplet.png"
import eighth from "./eighth.png"
import quarter from "./quarter.png"
import TextField from "@mui/material/TextField";

export default function BeatsPerMinuteTable(props) {
    let [ beatsPerNote, setBeatsPerNote ] = useState(0);

    const cells = [];
    for (let multiplier = 4; multiplier > 0; multiplier--) {
        cells.push(
            <TableCell key={multiplier} sx={{textAlign: 'left'}}>
                <BPMField multiplier={multiplier} beatsPerNote={beatsPerNote} setBeatsPerNote={setBeatsPerNote}/>
            </TableCell>
        )
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <colgroup>
                    <col style={{width:'30%'}}/>
                    <col style={{width:'10%'}}/>
                    <col style={{width:'10%'}}/>
                    <col style={{width:'10%'}}/>
                    <col style={{width:'10%'}}/>
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell><h2>Duration</h2></TableCell>
                        <TableCell><img height={"50px"} src={sixteenth} alt={""}/></TableCell>
                        <TableCell><img height={"58px"} src={triplet} alt={""}/></TableCell>
                        <TableCell><img height={"50px"} src={eighth} alt={""}/></TableCell>
                        <TableCell><img height={"50px"} src={quarter} alt={""}/></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>
                        </TableCell>
                        {cells}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

function BPMField(props) {
    const [focused, setFocused] = React.useState(false)
    const onFocus = () => setFocused(true)
    const onBlur = () => setFocused(false)

    let [value, setValue] = useState(0)

    const multiplier = props.multiplier
    const setBeatsPerNote = props.setBeatsPerNote
    const beatsPerNote = props.beatsPerNote

    useEffect(() => {
        if (!isNaN(value)) {
            setBeatsPerNote(value / multiplier)
        }
    }, [value, multiplier, setBeatsPerNote]);

    useEffect(() => {
        if (!focused)
            setValue(beatsPerNote * multiplier)
    }, [setValue, focused, beatsPerNote, multiplier]);

    return (
        <TextField id="filled-basic" label="BPM" variant="filled"
                   value={value} onChange={e => setValue(e.target.value)} onFocus={onFocus} onBlur={onBlur}/>
    )
}